import { ChartJsConfig } from "./chart-js-config";

export class KpiConfig {
    sufix: string = '';
    assignedColors: any[] = [];
    alertLimits: any[] = [];
    edaChart: ChartJsConfig;
    modifiedFontPoints: number = 0;
    backgroundColor: string = '';
    kpiColor: string = '';
    prefixImage: string = '';
    constructor(init?: Partial<KpiConfig>) {
        this.edaChart = new ChartJsConfig(
            init?.edaChart?.colors || [],
            init?.edaChart?.chartType || '',
            init?.edaChart?.addTrend || false,
            init?.edaChart?.addComparative || false,
            init?.edaChart?.showLabels || false,
            init?.edaChart?.showLabelsPercent || false,
            init?.edaChart?.numberOfColumns || 0,
            init?.edaChart?.assignedColors || [],
            init?.edaChart?.showPointLines || false,
            init?.edaChart?.showPredictionLines || false,
        );
        
        Object.assign(this, init);


    }
}